import { formatLongDate } from './format-date.js';
/**
 * Formats two `YYYY-MM-DD` dates as a readable en-ZA range.
 * Same-day:    "15 May 2026" (a single date, not a range)
 * Same-month:  "1 – 31 May 2026" (the shared month and year are stated once)
 * Cross-month: "1 May 2026 – 30 June 2026"
 *
 * A single day is one date, not a range: "15 – 15 May 2026" reads as a typo
 * rather than as one day's coverage. Every consumer wants the collapsed form -
 * a report period, a bank account's imported-line coverage, and a statement's
 * own period all describe a single day the same way - so the collapse lives
 * here rather than in a guard each caller has to remember.
 *
 * Lives here rather than beside one of its consumers because it is now shared
 * across unrelated surfaces: the ledger report pages (income statement, cash
 * flow) render a reporting period with it, and the bank-account header renders
 * the transaction-date span its imported statement lines cover. A route-folder
 * home would have made the second consumer a cross-domain UI import.
 *
 * Uses an en dash with spaces, per the house dash rule.
 */
export function formatPeriodRange(from, to) {
    if (from === to)
        return formatLongDate(from);
    const [fy, fm, fd] = from.split('-').map(Number);
    const [ty, tm] = to.split('-').map(Number);
    const sameMonthYear = fy === ty && fm === tm;
    if (sameMonthYear) {
        return `${fd} – ${formatLongDate(to)}`;
    }
    return `${formatLongDate(from)} – ${formatLongDate(to)}`;
}
/** A bounded period, or the complete history through the supplied end date. */
export function formatOpenPeriodRange(from, to) {
    return from ? formatPeriodRange(from, to) : `All time to ${formatLongDate(to)}`;
}
